// extracted by mini-css-extract-plugin
module.exports = {"provider":"SetMealEditor_style_provider__1BjQW"};